module.exports = __webpack_public_path__ + "img/copy.d8cb03bc.svg";